import React, { useState } from "react";
import { api } from "../utils/interceptor";
import { useApp } from "../context/AppState";
import cartService from "../services/cart.service";
import { resolveOfferProducts } from "../../shared/resolve-offer-products-client.js";

// Mock product data for local testing
const MOCK_PRODUCT_DATA = {
  "id": 7849227649163,
  "title": "The Complete Snowboard",
  "handle": "the-complete-snowboard",
  "description": "This <b>PREMIUM</b> <i>snowboard</i> is so <b>SUPER</b><i>DUPER</i> awesome!",
  "published_at": "2025-07-09T07:32:04-04:00",
  "created_at": "2025-07-09T07:32:04-04:00",
  "vendor": "Snowboard Vendor",
  "type": "snowboard",
  "tags": ["Premium", "Snow", "Snowboard", "Sport", "Winter"],
  "price": 69995,
  "price_min": 69995,
  "price_max": 69995,
  "available": true,
  "price_varies": false,
  "compare_at_price": null,
  "compare_at_price_min": 0,
  "compare_at_price_max": 0,
  "compare_at_price_varies": false,
  "variants": [
    {
      "id": 43629926875275,
      "title": "Ice",
      "option1": "Ice",
      "option2": null,
      "option3": null,
      "sku": null,
      "requires_shipping": true,
      "taxable": true,
      "featured_image": null,
      "available": true,
      "name": "The Complete Snowboard - Ice",
      "public_title": "Ice",
      "options": ["Ice"],
      "price": 69995,
      "weight": 4536,
      "compare_at_price": null,
      "inventory_management": "shopify",
      "barcode": null,
      "quantity_rule": {"min": 1, "max": null, "increment": 1},
      "quantity_price_breaks": [],
      "requires_selling_plan": false,
      "selling_plan_allocations": []
    },
    {
      "id": 43629926908043,
      "title": "Dawn",
      "option1": "Dawn",
      "option2": null,
      "option3": null,
      "sku": null,
      "requires_shipping": true,
      "taxable": true,
      "featured_image": null,
      "available": true,
      "name": "The Complete Snowboard - Dawn",
      "public_title": "Dawn",
      "options": ["Dawn"],
      "price": 69995,
      "weight": 4536,
      "compare_at_price": null,
      "inventory_management": "shopify",
      "barcode": null,
      "quantity_rule": {"min": 1, "max": null, "increment": 1},
      "quantity_price_breaks": [],
      "requires_selling_plan": false,
      "selling_plan_allocations": []
    },
    {
      "id": 43629926940811,
      "title": "Powder",
      "option1": "Powder",
      "option2": null,
      "option3": null,
      "sku": null,
      "requires_shipping": true,
      "taxable": true,
      "featured_image": null,
      "available": true,
      "name": "The Complete Snowboard - Powder",
      "public_title": "Powder",
      "options": ["Powder"],
      "price": 69995,
      "weight": 4536,
      "compare_at_price": null,
      "inventory_management": "shopify",
      "barcode": null,
      "quantity_rule": {"min": 1, "max": null, "increment": 1},
      "quantity_price_breaks": [],
      "requires_selling_plan": false,
      "selling_plan_allocations": []
    },
    {
      "id": 43629926973579,
      "title": "Electric",
      "option1": "Electric",
      "option2": null,
      "option3": null,
      "sku": null,
      "requires_shipping": true,
      "taxable": true,
      "featured_image": null,
      "available": true,
      "name": "The Complete Snowboard - Electric",
      "public_title": "Electric",
      "options": ["Electric"],
      "price": 69995,
      "weight": 4536,
      "compare_at_price": null,
      "inventory_management": "shopify",
      "barcode": null,
      "quantity_rule": {"min": 1, "max": null, "increment": 1},
      "quantity_price_breaks": [],
      "requires_selling_plan": false,
      "selling_plan_allocations": []
    },
    {
      "id": 43629927006347,
      "title": "Sunset",
      "option1": "Sunset",
      "option2": null,
      "option3": null,
      "sku": null,
      "requires_shipping": true,
      "taxable": true,
      "featured_image": null,
      "available": true,
      "name": "The Complete Snowboard - Sunset",
      "public_title": "Sunset",
      "options": ["Sunset"],
      "price": 69995,
      "weight": 4536,
      "compare_at_price": null,
      "inventory_management": "shopify",
      "barcode": null,
      "quantity_rule": {"min": 1, "max": null, "increment": 1},
      "quantity_price_breaks": [],
      "requires_selling_plan": false,
      "selling_plan_allocations": []
    }
  ],
  "images": ["//cdn.shopify.com/s/files/1/0690/8939/4827/files/Main_589fc064-24a2-4236-9eaf-13b2bd35d21d.jpg?v=1752060725"],
  "featured_image": "//cdn.shopify.com/s/files/1/0690/8939/4827/files/Main_589fc064-24a2-4236-9eaf-13b2bd35d21d.jpg?v=1752060725",
  "options": [
    {
      "name": "Color",
      "position": 1,
      "values": ["Ice", "Dawn", "Powder", "Electric", "Sunset"]
    }
  ],
  "url": "/products/the-complete-snowboard",
  "media": [
    {
      "alt": "Top and bottom view of a snowboard. The top view shows abstract circles and lines in shades of teal. The bottom view shows abstract circles and lines in shades of purple and blue with the text 'SHOPIFY' in a sans serif typeface on top.",
      "id": 29288403861643,
      "position": 1,
      "preview_image": {
        "aspect_ratio": 1.0,
        "height": 1600,
        "width": 1600,
        "src": "https://cdn.shopify.com/s/files/1/0690/8939/4827/files/Main_589fc064-24a2-4236-9eaf-13b2bd35d21d.jpg?v=1752060725"
      },
      "aspect_ratio": 1.0,
      "height": 1600,
      "media_type": "image",
      "src": "https://cdn.shopify.com/s/files/1/0690/8939/4827/files/Main_589fc064-24a2-4236-9eaf-13b2bd35d21d.jpg?v=1752060725",
      "width": 1600
    }
  ],
  "requires_selling_plan": false,
  "selling_plan_groups": []
};

export const usePopup = () => {
  const { appState, dispatch } = useApp();

  const [isLoading, setLoading] = useState(false);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);
  const [cachedProducts, setCachedProducts] = useState(null);
  const [lastFetchTime, setLastFetchTime] = useState(null);

  const fetchRecommendedProduct = async (productId, productHandle) => {
    const baseRoute = window?.Shopify?.shop || window.location.hostname;

    try {
      const result = await api.get(`/api/public/product-recommendation?product_id=${productId}&baseRoute=${baseRoute}&productHandle=${productHandle}`);
      return result?.data?.data;
    } catch (error) {
      console.log(error);
    }
  }

  const fetchProductByHandleOrId = async (productHandle) => {
    const baseRoute = window?.Shopify?.shop || window.location.hostname;

    try {
      const result = await api.get(`/api/public/shopify-product?baseRoute=${baseRoute}&productHandle=${productHandle}`);
      return result?.data?.data;
    } catch (error) {
      console.log(error);
    }
  }

  // Helper function to check if we're in local testing mode
  const isLocalTesting = () => {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1';
  };

  // Mock Shopify API call for local testing
  const mockFetchProductByHandle = async (handle) => {
    console.log('[Local Testing] Using mock product data for handle:', handle);
    // Return mock data for local testing
    return MOCK_PRODUCT_DATA;
  };

  // Resolve offer products — storefront GraphQL first, server /product/random fallback.
  const fetchOfferProducts = async (
    productsToOffer,
    forceRefresh = false,
    productCount = 1,
    allowMultipleProducts = false,
    debugPopup = null,
    offerContext = {}
  ) => {
    try {
      const now = Date.now();
      const cacheAge = now - (lastFetchTime || 0);
      const cacheValid = cacheAge < 5 * 60 * 1000;

      if (!forceRefresh && cachedProducts && cacheValid) {
        console.log("[ProductAPI] Using cached products");
        return cachedProducts;
      }

      if (isLoadingProducts) {
        console.log("[ProductAPI] Already loading products, skipping call");
        return cachedProducts;
      }

      setIsLoadingProducts(true);
      console.log("[ProductAPI] Resolving offer products...");

      if (!productsToOffer) return null;

      const resolved = await resolveOfferProducts({
        productsToOffer,
        productCount,
        allowMultipleProducts,
        preferCart: offerContext.preferCart === true,
        surface: offerContext.surface || "",
        contextProduct: offerContext.contextProduct || null,
        apiGet: api.get.bind(api),
        caller: "react-usePopup",
        debugPopup,
      });

      if (resolved) {
        setCachedProducts(resolved);
        setLastFetchTime(now);
      }

      return resolved;
    } catch (error) {
      console.error("Error resolving offer products:", error);
      return null;
    } finally {
      setIsLoadingProducts(false);
    }
  };

  /** @deprecated Use fetchOfferProducts */
  const fetchRandomProduct = fetchOfferProducts;

  return {
    isLoading,
    isLoadingProducts,
    fetchRecommendedProduct,
    fetchProductByHandleOrId,
    fetchOfferProducts,
    fetchRandomProduct,
  };
};